"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.secondReg = exports.dateReg = void 0;
var secondReg = /^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})$/;
exports.secondReg = secondReg;
var dateReg = /^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2}) (\d{1,2}):(\d{1,2}):(\d{1,2})$/;
exports.dateReg = dateReg;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/algorithm/lib/constants/time.js
// module id = wRLm
// module chunks = 1